import React, {Component, Fragment} from 'react';
import {withTranslation} from "react-i18next";
import {
  withRouter,
  GelContentRow,
  StyleguideContext,
  RegularCard, GelContentColumn, Image, Notice, FormBack, Sanitize
} from 'cw-styleguide-react';
import Content from "../Content";
import {BreadcrumbsItem} from "react-breadcrumbs-dynamic";
import {route} from "../routes";
import JobRoleCard from "../components/JobRoleCard";
import JobRightCard from "../components/JobRightCard";
import JobQualificationsCard from "../components/JobQualificationsCard";
import JobThinkCard from "../components/JobThinkCard";
import Helmet from 'react-helmet';

class JobQualificationsView extends Component {

  componentDidMount() {
    window.initialiseCard();
    this.context.setLanguageUrl(this.props.data.slugTrans + route('qualifications',{},this.props.i18n.language === 'cy' ? 'en' : 'cy'));
  }
  render() {
    return (
      <Fragment>
        <Helmet>
          <title>{this.props.data.name} - {this.props.data.qualificationStatic} | {this.props.t('app.name')}</title>
        </Helmet>
        <BreadcrumbsItem glyph='user' to={'/' + this.props.data.slug + '/right'}>
          {this.props.data.qualificationStatic}
        </BreadcrumbsItem>
        <h1>{this.props.data.qualificationStatic}</h1>

        {this.props.data.qualificationImages.map((item, index) => {
          return <>
            <div className={"gel-lg-mb-40 gel-md-mb-40 gel-sm-mb-40 gel-xs-mb-40"}>
              <GelContentRow>
                <GelContentColumn md={6}>
                  <Image source={item.image.src} alternative={item.image.alt}/>
                </GelContentColumn>
                <GelContentColumn md={6}>
                  <div className={"gel-fs-24"}><strong><Sanitize html={item.title}/></strong></div>
                </GelContentColumn>
              </GelContentRow>
            </div>
          </>
        })}

        <Notice type={'info'}>
            <div dangerouslySetInnerHTML={{ __html: this.props.data.informationNotice}}></div>
        </Notice>

        <hr/>
        <h2>{this.props.t('misc.moreInformation')}</h2>

        <GelContentRow>
          <JobRoleCard slug={this.props.data.slug}  data={this.props.data}/>
          <JobRightCard slug={this.props.data.slug}  data={this.props.data}/>
          <JobThinkCard slug={this.props.data.slug}  data={this.props.data}/>

        </GelContentRow>

        <FormBack url={'/' + this.props.data.slug} title={this.props.data.name}/>
      </Fragment>
    )
  }
}

JobQualificationsView.contextType = StyleguideContext;

export default withRouter(withTranslation(['local', 'styleguide'])(JobQualificationsView));
